import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const ClipartFilterMenu = props => {
  return (
    <Menu
      elevation={0}
      open={props.open}
      anchorEl={props.anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={props.handleRequestClose}
      keepMounted
    >
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('ACTIONS')}>Actions</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('ANIMALS')}>Animals</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('BLUE_WORDS')}>Blue Words</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('CLOTHING')}>Clothing</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('CONSTRUCTION')}>Construction</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('FOOD')}>Food</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('GREEN_WORDS')}>Green Words</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('HOUSEHOLD')}>Household</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('INSECTS')}>Insects</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('MEDICAL')}>Medical</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('NATURE')}>Nature</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('PINK_WORDS')}>Pink Words</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('PURPLE_WORDS')}>Purple Words</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('SCHOOL')}>School</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('SPORTS')}>Sports</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('TRANSPORTATION')}>Transportation</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterClipartCategory('TRAVEL')}>Travel</MenuItem>
    </Menu>
  );
};

ClipartFilterMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  handleRequestClose: PropTypes.func.isRequired,
  handleClickFilterClipartCategory: PropTypes.func.isRequired,
};

export default ClipartFilterMenu;
